module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('text-overlay', {
    attrs: {
      "show": _vm.querying_api,
      "text": _vm.overlay_text,
      "no-wrap": "",
      "fixed": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tribal-renter-forms"
    }
  }, [(_vm.needsTribalForm) ? _c('div', [_c('h5', [_vm._v("Are you a Southern Ute Tribal Member, member of another Native American Tribe, or a person of Native American descent?")]), _vm._v(" "), _c('div', [_vm._v("*Installation costs waived for Self-identifying Tribal Members.")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "tribal-member-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_tribal),
      expression: "form_data.is_tribal"
    }],
    attrs: {
      "type": "radio",
      "name": "tribal-status"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.form_data.is_tribal, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_tribal", true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Yes")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "not-tribal-member-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_tribal),
      expression: "form_data.is_tribal"
    }],
    attrs: {
      "type": "radio",
      "name": "tribal-status"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.form_data.is_tribal, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_tribal", false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), (_vm.needsRenterForm) ? _c('div', [(_vm.needsTribalForm) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Do you own or rent your home?")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "owner-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_owner),
      expression: "form_data.is_owner"
    }],
    attrs: {
      "type": "radio",
      "name": "rent-type"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.form_data.is_owner, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_owner", true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Own")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "renter-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_owner),
      expression: "form_data.is_owner"
    }],
    attrs: {
      "type": "radio",
      "name": "rent-type"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.form_data.is_owner, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_owner", false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Rent")])])])]) : _vm._e(), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('tribal-renter-forms')
      }
    }
  }, [(_vm.isRenter && _vm.needsRenterForm && _vm.rentersAllowed) ? _c('div', [_c('br'), _vm._v(" "), _c('span', [_vm._v("Renters must gain approval from the homeowner. Please enter the owner's contact information.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('xm-input', {
    staticClass: "col-md-5",
    attrs: {
      "name": "name",
      "label": "Owner name",
      "pattern": _vm.regex.name,
      "required": "",
      "error": "Enter owner name"
    },
    model: {
      value: (_vm.form_data.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_name", $$v)
      },
      expression: "form_data.owner_name"
    }
  }), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "col-md-3",
    attrs: {
      "name": "phone",
      "label": "Owner phone",
      "pattern": _vm.regex.phone,
      "required": "",
      "error": "Please enter a valid phone number"
    },
    model: {
      value: (_vm.form_data.owner_phone),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_phone", $$v)
      },
      expression: "form_data.owner_phone"
    }
  }), _vm._v(" "), _c('xm-input', {
    staticClass: "col-md-4",
    attrs: {
      "name": "email",
      "label": "Owner email",
      "type": "email",
      "pattern": _vm.regex.email,
      "required": "",
      "error": "Please enter a valid email address"
    },
    model: {
      value: (_vm.form_data.owner_email),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_email", $$v)
      },
      expression: "form_data.owner_email"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('tribal-renter-forms')
      }
    }
  }, [(_vm.isRenter && _vm.needsRenterForm && !_vm.rentersAllowed) ? _c('div', [_c('br'), _vm._v(" "), _c('h5', [_vm._v("Owner approval form")]), _vm._v(" "), _c('span', [_vm._v("Renters must gain approval from the homeowner. Please download and ask your landlord to complete the approval form. Once completed, please contact XMission sales to complete the signup process.")]), _c('br'), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "submit-button",
    attrs: {
      "variant": "primary",
      "href": "https://asset.xmission.com/pdf/lehi-fiber-rental-agreement.pdf",
      "target": "_blank",
      "download": "lehi-fiber-rental-agreement.pdf"
    }
  }, [_vm._v("\n          Download rental approval form\n        ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Your contact information")]), _vm._v(" "), _c('span', [_vm._v("If you would like sales to reach out to you please provide your contact information.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('xm-input', {
    staticClass: "col-md-5",
    attrs: {
      "name": "name",
      "label": "Full Name",
      "pattern": _vm.regex.name,
      "required": "",
      "error": "Enter your name"
    },
    model: {
      value: (_vm.form_data.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_name", $$v)
      },
      expression: "form_data.owner_name"
    }
  }), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "col-md-3",
    attrs: {
      "name": "phone",
      "label": "Phone Number",
      "pattern": _vm.regex.phone,
      "required": "",
      "error": "Please enter a valid phone number"
    },
    model: {
      value: (_vm.form_data.owner_phone),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_phone", $$v)
      },
      expression: "form_data.owner_phone"
    }
  }), _vm._v(" "), _c('xm-input', {
    staticClass: "col-md-4",
    attrs: {
      "name": "email",
      "label": "Email Address",
      "type": "email",
      "pattern": _vm.regex.email,
      "required": "",
      "error": "Please enter a valid email address"
    },
    model: {
      value: (_vm.form_data.owner_email),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_email", $$v)
      },
      expression: "form_data.owner_email"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "submit-button",
    attrs: {
      "disabled": !_vm.validOwnerContact,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addRenterContact()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daa54c52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/create/CustomerDetails.vue
// module id = 1348
// module chunks = 16